var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { SubmissionSummary } from "./SubmissionSummary";
export class CorrectionSubmissionSummary extends SubmissionSummary {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "NumberOfDeletedPayees");
    /**
     */
    __publicField(this, "NumberOfDeletedTransactions");
    /**
     */
    __publicField(this, "NumberOfModifiedPayees");
    /**
     */
    __publicField(this, "NumberOfModifiedTransactions");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CorrectionSubmissionSummary
     */
    __publicField(this, "$type", "V1.Cesop.Periods.CorrectionSubmissionSummary");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      this.NumberOfDeletedPayees = _data["NumberOfDeletedPayees"];
      this.NumberOfDeletedTransactions = _data["NumberOfDeletedTransactions"];
      this.NumberOfModifiedPayees = _data["NumberOfModifiedPayees"];
      this.NumberOfModifiedTransactions = _data["NumberOfModifiedTransactions"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["NumberOfDeletedPayees"] = this.NumberOfDeletedPayees;
    _data["NumberOfDeletedTransactions"] = this.NumberOfDeletedTransactions;
    _data["NumberOfModifiedPayees"] = this.NumberOfModifiedPayees;
    _data["NumberOfModifiedTransactions"] = this.NumberOfModifiedTransactions;
    return _data;
  }
}
